import { appStore, IEvent, MessageBus } from '@tom-ui/utils'
import { CreatePierRequest, PierResponse, UpdatePierRequest } from '@yard/app/api'
import { EventTypes } from '@yard/messages/eventsTypes'
import { DeleteResponse } from '@yard/messages/models/delete-response.model'
import { pierService } from '../services/pier.service'
import { BaseEntityStore } from './base/BaseEntityStore'

export class PierStore extends BaseEntityStore<PierResponse> {
  private isFetched = false
  private readonly disposers: Array<() => void> = []

  constructor(private readonly messageBus: MessageBus) {
    super()

    this.disposers.push(
      this.messageBus.subscribeEvent<PierResponse>(
        EventTypes.PierUpsertedEvent,
        this.handleUpsertedEvent,
      ),
      this.messageBus.subscribeEvent<DeleteResponse>(
        EventTypes.PierDeletedEvent,
        this.handleDeletedEvent,
      ),
    )
  }

  dispose(): void {
    this.disposers.forEach(d => d())
    this.disposers.length = 0
  }

  async loadPiers() {
    if (this.isFetched) return
    try {
      const piers = await pierService.load()
      this.updateStoreItems(piers)
      this.isFetched = true
    } catch (e) {
      appStore.setShowAlert('error', (e as any)?.response?.data?.detail ?? 'An error occurred')
    }
  }

  async createPier(request: CreatePierRequest) {
    await pierService.create(request)
  }

  async updatePier(request: UpdatePierRequest) {
    await pierService.update(request)
  }

  async deletePier(id: string) {
    await pierService.delete(id)
  }

  private handleUpsertedEvent = (event: IEvent<PierResponse>) => {
    const response = event.payload
    if (!response) return

    this.updateStoreItem(response, response.id)
  }

  private handleDeletedEvent = (event: IEvent<DeleteResponse>) => {
    const response = event.payload
    if (!response) return
    this.deleteStoreItem(response.id)
  }
}
